import dayjs from 'dayjs'
import _ from 'lodash'

const setupWindow = () => {
  window.$dayjs = dayjs
  window.$lodash = _
}

export default setupWindow
